export const actions = {
  TRANSPORTISTAS_LOAD_REQUESTED: 'TRANSPORTISTAS_LOAD_REQUESTED',
  TRANSPORTISTAS_LOAD_SUCCEEDED: 'TRANSPORTISTAS_LOAD_SUCCEEDED',
  TRANSPORTISTAS_LOAD_FAILED: 'TRANSPORTISTAS_LOAD_FAILED',

  TRANSPORTISTAS_VACACIONES_LOAD_REQUESTED: 'TRANSPORTISTAS_VACACIONES_LOAD_REQUESTED',
  TRANSPORTISTAS_VACACIONES_LOAD_SUCCEEDED: 'TRANSPORTISTAS_VACACIONES_LOAD_SUCCEEDED',
  TRANSPORTISTAS_VACACIONES_LOAD_FAILED: 'TRANSPORTISTAS_VACACIONES_LOAD_FAILED',

  TRANSPORTISTAS_COMENTARIOS_LOAD_REQUESTED: 'TRANSPORTISTAS_COMENTARIOS_LOAD_REQUESTED',
  TRANSPORTISTAS_COMENTARIOS_LOAD_SUCCEEDED: 'TRANSPORTISTAS_COMENTARIOS_LOAD_SUCCEEDED',
  TRANSPORTISTAS_COMENTARIOS_LOAD_FAILED: 'TRANSPORTISTAS_COMENTARIOS_LOAD_FAILED',

  TRANSPORTISTAS_VISIBLES_LOAD_REQUESTED: 'TRANSPORTISTAS_VISIBLES_LOAD_REQUESTED',
  TRANSPORTISTAS_VISIBLES_LOAD_SUCCEEDED: 'TRANSPORTISTAS_VISIBLES_LOAD_SUCCEEDED',
  TRANSPORTISTAS_VISIBLES_LOAD_FAILED: 'TRANSPORTISTAS_VISIBLES_LOAD_FAILED',

  TRANSPORTISTA_BY_ID_LOAD_REQUESTED: 'TRANSPORTISTA_BY_ID_LOAD_REQUESTED',
  TRANSPORTISTA_BY_ID_LOAD_SUCCEEDED: 'TRANSPORTISTA_BY_ID_LOAD_SUCCEEDED',
  TRANSPORTISTA_BY_ID_LOAD_FAILED: 'TRANSPORTISTA_BY_ID_LOAD_FAILED',

  TRANSPORTISTA_UPDATE_REQUESTED: 'TRANSPORTISTA_UPDATE_REQUESTED',
  TRANSPORTISTA_UPDATE_SUCCEEDED: 'TRANSPORTISTA_UPDATE_SUCCEEDED',
  TRANSPORTISTA_UPDATE_FAILED: 'TRANSPORTISTA_UPDATE_FAILED',

  TRANSPORTISTA_INSERT_REQUESTED: 'TRANSPORTISTA_INSERT_REQUESTED',
  TRANSPORTISTA_INSERT_SUCCEEDED: 'TRANSPORTISTA_INSERT_SUCCEEDED',
  TRANSPORTISTA_INSERT_FAILED: 'TRANSPORTISTA_INSERT_FAILED',

  TRANSPORTISTA_DELETE_REQUESTED: 'TRANSPORTISTA_DELETE_REQUESTED',
  TRANSPORTISTA_DELETE_SUCCEEDED: 'TRANSPORTISTA_DELETE_SUCCEEDED',
  TRANSPORTISTA_DELETE_FAILED: 'TRANSPORTISTA_DELETE_FAILED',

  TRANSPORTISTA_VACACIONES_INSERT_REQUESTED: 'TRANSPORTISTA_VACACIONES_INSERT_REQUESTED',
  TRANSPORTISTA_VACACIONES_INSERT_SUCCEEDED: 'TRANSPORTISTA_VACACIONES_INSERT_SUCCEEDED',
  TRANSPORTISTA_VACACIONES_INSERT_FAILED: 'TRANSPORTISTA_VACACIONES_INSERT_FAILED',

  TRANSPORTISTA_VACACIONES_DELETE_REQUESTED: 'TRANSPORTISTA_VACACIONES_DELETE_REQUESTED',
  TRANSPORTISTA_VACACIONES_DELETE_SUCCEEDED: 'TRANSPORTISTA_VACACIONES_DELETE_SUCCEEDED',
  TRANSPORTISTA_VACACIONES_DELETE_FAILED: 'TRANSPORTISTA_VACACIONES_DELETE_FAILED',

  TRANSPORTISTA_COMENTARIOS_INSERT_REQUESTED: 'TRANSPORTISTA_COMENTARIOS_INSERT_REQUESTED',
  TRANSPORTISTA_COMENTARIOS_INSERT_SUCCEEDED: 'TRANSPORTISTA_COMENTARIOS_INSERT_SUCCEEDED',
  TRANSPORTISTA_COMENTARIOS_INSERT_FAILED: 'TRANSPORTISTA_COMENTARIOS_INSERT_FAILED',

  TRANSPORTISTA_COMENTARIOS_ORDEN_UPDATED: 'TRANSPORTISTA_COMENTARIOS_ORDEN_UPDATED',

  TRANSPORTISTA_COMENTARIOS_DELETE_REQUESTED: 'TRANSPORTISTA_COMENTARIOS_DELETE_REQUESTED',
  TRANSPORTISTA_COMENTARIOS_DELETE_SUCCEEDED: 'TRANSPORTISTA_COMENTARIOS_DELETE_SUCCEEDED',
  TRANSPORTISTA_COMENTARIOS_DELETE_FAILED: 'TRANSPORTISTA_COMENTARIOS_DELETE_FAILED',

  TRANSPORTISTA_VISIBLES_INSERT_REQUESTED: 'TRANSPORTISTA_VISIBLES_INSERT_REQUESTED',
  TRANSPORTISTA_VISIBLES_INSERT_SUCCEEDED: 'TRANSPORTISTA_VISIBLES_INSERT_SUCCEEDED',
  TRANSPORTISTA_VISIBLES_INSERT_FAILED: 'TRANSPORTISTA_VISIBLES_INSERT_FAILED',

  TRANSPORTISTA_VISIBLES_DELETE_REQUESTED: 'TRANSPORTISTA_VISIBLES_DELETE_REQUESTED',
  TRANSPORTISTA_VISIBLES_DELETE_SUCCEEDED: 'TRANSPORTISTA_VISIBLES_DELETE_SUCCEEDED',
  TRANSPORTISTA_VISIBLES_DELETE_FAILED: 'TRANSPORTISTA_VISIBLES_DELETE_FAILED',

  TRANSPORTISTA_CAMBIAR_VISIBLES_TODOS_REQUESTED: 'TRANSPORTISTA_CAMBIAR_VISIBLES_TODOS_REQUESTED',
  TRANSPORTISTA_CAMBIAR_VISIBLES_TODOS_SUCCEEDED: 'TRANSPORTISTA_CAMBIAR_VISIBLES_TODOS_SUCCEEDED',
  TRANSPORTISTA_CAMBIAR_VISIBLES_TODOS_FAILED: 'TRANSPORTISTA_CAMBIAR_VISIBLES_TODOS_FAILED',
}

export const getTransportistasAction = dispatch => {
  dispatch({
    type: actions.TRANSPORTISTAS_LOAD_REQUESTED,
  })
}

export const getTransportistasVacacionesAction = dispatch => {
  dispatch({
    type: actions.TRANSPORTISTAS_VACACIONES_LOAD_REQUESTED,
  })
}

export const getTransportistasComentariosAction = (dispatch, payload) => {
  dispatch({
    type: actions.TRANSPORTISTAS_COMENTARIOS_LOAD_REQUESTED,
    payload,
  })
}

export const getTransportistasVisiblesAction = (dispatch, payload) => {
  dispatch({
    type: actions.TRANSPORTISTAS_VISIBLES_LOAD_REQUESTED,
    payload,
  })
}

export const getTransportistaAction = (dispatch, id) => {
  dispatch({
    type: actions.TRANSPORTISTA_BY_ID_LOAD_REQUESTED,
    id,
  })
}

export const insertTransportistaAction = (dispatch, payload) => {
  dispatch({
    type: actions.TRANSPORTISTA_INSERT_REQUESTED,
    payload,
  })
}

export const updateTransportistaAction = (dispatch, payload) => {
  dispatch({
    type: actions.TRANSPORTISTA_UPDATE_REQUESTED,
    payload,
  })
}

export const deleteTransportistaAction = (dispatch, id) => {
  dispatch({
    type: actions.TRANSPORTISTA_DELETE_REQUESTED,
    payload: id,
  })
}

export const insertTransportistaVacacionesAction = (dispatch, payload) => {
  dispatch({
    type: actions.TRANSPORTISTA_VACACIONES_INSERT_REQUESTED,
    payload,
  })
}

export const deleteTransportistaVacacionesAction = (dispatch, id) => {
  dispatch({
    type: actions.TRANSPORTISTA_VACACIONES_DELETE_REQUESTED,
    id,
  })
}

export const insertTransportistaComentariosAction = (dispatch, payload) => {
  dispatch({
    type: actions.TRANSPORTISTA_COMENTARIOS_INSERT_REQUESTED,
    payload,
  })
}

export const deleteTransportistaComentariosAction = (dispatch, id) => {
  dispatch({
    type: actions.TRANSPORTISTA_COMENTARIOS_DELETE_REQUESTED,
    id,
  })
}

// Cambia en el store el orden de los comentarios ya movidos; el guardado en el servidor lo hace el componente
export const setOrdenComentariosTransportistaAction = (dispatch, payload) => {
  dispatch({
    type: actions.TRANSPORTISTA_COMENTARIOS_ORDEN_UPDATED,
    payload,
  })
}

export const insertTransportistaVisiblesAction = (dispatch, payload) => {
  dispatch({
    type: actions.TRANSPORTISTA_VISIBLES_INSERT_REQUESTED,
    payload,
  })
}

export const deleteTransportistaVisiblesAction = (dispatch, id) => {
  dispatch({
    type: actions.TRANSPORTISTA_VISIBLES_DELETE_REQUESTED,
    id,
  })
}

export const cambiarTodosTransportistaVisiblesAction = (dispatch, payload) => {
  dispatch({
    type: actions.TRANSPORTISTA_CAMBIAR_VISIBLES_TODOS_REQUESTED,
    payload,
  })
}
